
import checkUserCanMakeDeals from './guards/checkUserCanMakeDeals'

const Questionnaire = () => import('./pages/Questionnaire')

const routeDefaults = {
  beforeEnter: checkUserCanMakeDeals,
  props: ({ query }) => ({ query }),
}

export default [
  {
    path: '/questionnaire',
    name: 'QuestionnaireEntry',
    component: Questionnaire,
    redirect: { name: 'ChooseDealType' },
    meta: {
      accessAnyWhere: true,
      title: 'Questionnaire',
    },
  },
  {
    path: '/questionnaire/choose-deal-type',
    name: 'ChooseDealType',
    component: Questionnaire,
    meta: {
      accessAnyWhere: true,
      title: 'Questionnaire: Choose Deal Type',
    },
  },
  {
    path: '/questionnaire/choose-practice',
    name: 'ChoosePractice',
    component: Questionnaire,
    meta: {
      accessAnyWhere: true,
      title: 'Questionnaire: Choose Practice',
    },
  },
  {
    path: '/questionnaire/choose-deal-size',
    name: 'ChooseDealSize',
    component: Questionnaire,
    meta: {
      accessAnyWhere: true,
      title: 'Questionnaire: Choose Deal Size',
    },
  },
  {
    path: '/questionnaire/choose-loan-type',
    name: 'ChooseLoanType',
    component: Questionnaire,
    meta: {
      accessAnyWhere: true,
      title: 'Questionnaire: Choose Loan Type',
    },
  },
  {
    path: '/questionnaire/choose-repay-loan',
    name: 'ChooseRepayLoan',
    component: Questionnaire,
    meta: {
      accessAnyWhere: true,
      title: 'Questionnaire: Choose Loan Repayment',
    },
  },
  {
    path: '/questionnaire/choose-credit-score',
    name: 'ChooseCreditScore',
    component: Questionnaire,
    meta: {
      accessAnyWhere: true,
      title: 'Questionnaire: Choose Credit Score',
    },
  },
  {
    path: '/questionnaire/choose-lender-features',
    name: 'ChooseLenderFeatures',
    component: Questionnaire,
    meta: {
      accessAnyWhere: true,
      title: 'Questionnaire: Choose Lender Features',
    },
  },
  {
    path: '/questionnaire/choose-issues',
    name: 'ChooseIssues',
    component: Questionnaire,
    meta: {
      accessAnyWhere: true,
      title: 'Questionnaire: Choose Disclosure Information',
    },
  },
  {
    path: '/questionnaire/choose-deadline',
    name: 'ChooseDeadline',
    component: Questionnaire,
    meta: {
      accessAnyWhere: true,
      title: 'Questionnaire: Choose Deadline',
    },
  },
  {
    path: '/questionnaire/enter-phone',
    name: 'EnterPhoneNumber',
    component: Questionnaire,
    meta: {
      accessAnyWhere: true,
      title: 'Questionnaire: Enter Phone Number',
    },
  },
].map(route => Object.assign({}, routeDefaults, route))
